import { Answer } from "@/api/minutes-api.ts";

export default function AnswerFormData(answer: Answer) {
  const d = new FormData();
  d.append("id", String(answer.id));
  d.append("title", answer.title);
  d.append("note", answer.note);
  answer.answers.forEach((a, i) => {
    d.append(`answers[${i}][id]`, String(a.id));
    d.append(`answers[${i}][note]`, a.note);
    d.append(`answers[${i}][secret]`, String(a.secret));
    d.append(`answers[${i}][skip]`, String(a.skip));
    a.options.forEach((o, x) => {
      d.append(`answers[${i}][options][${x}][id]`, String(o.id));
      d.append(`answers[${i}][options][${x}][text]`, o.text);
      d.append(`answers[${i}][options][${x}][selected]`, String(o.selected));
    });
  });
  return d;
}
